import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  IconButton,
  TableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import { formatPaginationLabel } from "../pagination/helpers";
import { TablePaginationProps } from "../pagination/types";
import SortField, { SortFieldProps } from "./SortField";
import { TableHeadStyled } from "./styled";
import { StripedTableHeader } from "./types"; // const paginationProps = {

interface Props {
  columnHeaders: string[] | StripedTableHeader[];
  pagination?: TablePaginationProps;
  sortProps?: SortFieldProps;
  toggleSelectAll?: () => void;
  allSelected?: boolean;
  indeterminate?: boolean;
  selectableRows?: boolean;
  size?: "small" | "medium";
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

const TableHeader = ({
  columnHeaders,
  pagination,
  sortProps,
  toggleSelectAll,
  allSelected,
  indeterminate,
  selectableRows,
  size = "medium",
  isCollapsed,
  onToggleCollapse,
}: Props) => {
  const getHeaderProps = (header: string | StripedTableHeader) => {
    const key = typeof header === "string" ? header : header.key;
    const align = typeof header === "string" ? "left" : header.align ?? "left";
    const width =
      typeof header === "string" ? undefined : header.width ?? "auto";
    const label = typeof header === "string" ? header : header.label;

    return { key, align, width, label, size };
  };

  return (
    <TableHeadStyled>
      {(pagination || sortProps) && (
        <TableRow>
          <TableCell colSpan={1000} sx={{ border: "none", padding: 0 }}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              width="100%"
            >
              {sortProps && <SortField {...sortProps} />}
              {pagination && (
                <TablePagination
                  component="div"
                  sx={{ border: "none" }}
                  count={pagination.count.value}
                  page={pagination.pageIndex}
                  rowsPerPage={pagination.pageSize}
                  onPageChange={pagination.onPageChange}
                  rowsPerPageOptions={[]}
                  labelDisplayedRows={(args) =>
                    formatPaginationLabel(pagination.count, args)
                  }
                />
              )}
            </Box>
          </TableCell>
        </TableRow>
      )}
      <TableRow>
        {selectableRows && (
          <TableCell padding="checkbox">
            <Checkbox
              checked={allSelected}
              indeterminate={indeterminate}
              onChange={toggleSelectAll}
            />
          </TableCell>
        )}

        {columnHeaders.map((header, index) => {
          const { key, label, align, ...restProps } = getHeaderProps(header);
          const showToggleButton =
            index === columnHeaders.length - 1 && !!onToggleCollapse;
          return (
            <TableCell
              key={key}
              {...restProps}
              align={showToggleButton ? "right" : align}
            >
              {label}
              {showToggleButton && (
                <IconButton size="small" onClick={onToggleCollapse}>
                  {isCollapsed ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHeadStyled>
  );
};

export default TableHeader;
